import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
const ImprovementsComponent = props => {
  const {
    improvementsTitle,
    improvementsSubTitle,
    improvementsDescription,
    improvementsSubDescription,
    improvementsText,
    improvementsSubText,
    improvementsDescriptionCol,
    improvementsSubDescriptionCol,
    improvementsTextCol,
    improvementsDescriptionHealthcare,
    ImprovementsImage,
    improvementsResult,
    improvementsResultIdeas,
    improvementsResultIdeasNumber,
    improvementsResultInvolved,
    improvementsResultInvolvedNumber,
    improvementsResultStakeholders,
    improvementsResultStakeholdersNumber,
    improvementsResultExranal,
    improvementsResultExranalNumber,
    improvementsResultAnnual,
    improvementsResultAnnualNumber,
    improvementsSubDescriptionHealthcare,
    isBusinessDeveloper,
  } = props;
  return (
    <div className="improvements-section">
      <div className="full-container-article">
        <h2 className="article-business-section-title">{improvementsTitle}</h2>
        <p className="article-business-section-text article-business-section-text">
          {improvementsSubTitle}
        </p>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <p className="improvements-section-description article-business-section-text">
              {improvementsDescriptionCol}
            </p>
            <p className="improvements-section-description article-business-section-text">
              {improvementsSubDescriptionCol}
            </p>
            <p className="improvements-section-description article-business-section-text">
              {improvementsTextCol}
            </p>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <GatsbyImage
              image={ImprovementsImage}
              className="improvements-section-image"
              style={{ width: '100%' }}
              alt={''}
            />
          </div>
        </div>
        <p className="improvements-section-description article-business-section-text">
          {improvementsDescription}
        </p>
        <p className="improvements-section-description article-business-section-text">
          {improvementsSubDescription}
        </p>
        <p className="improvements-section-description article-business-section-text">
          {improvementsText}
        </p>
        <p className="improvements-section-description article-business-section-text">
          {improvementsSubText}
        </p>
        {isBusinessDeveloper && (
          <div>
            <ul>
              <li>
                <p className="improvements-section-description article-business-section-text">
                  - The executives need to care about this specific opportunity,
                  even if it isn’t very big. But unfortunately, executives often
                  focus only on the huge, important deals and have little
                  interest in anything else.{' '}
                </p>
              </li>
              <li>
                <p className="improvements-section-description article-business-section-text">
                  - The product team needs to build it, which is met with several
                  other problems such as timing is awful and it would have to be
                  built a year later.
                </p>
              </li>
              <li>
                <p className="improvements-section-description article-business-section-text">
                  - If it isn’t on the product roadmap, it might be met with
                  resistance because there isn’t enough budget, and it may
                  conflict with what existing customers are asking for.
                </p>
              </li>
              <li>
                <p className="improvements-section-description article-business-section-text">
                  - Finance then needs to approve the investment on every new
                  partnership, and since most of these partnerships come
                  off-budget cycle, they are met with resistance because they
                  don’t have the funds to back all of them up.
                </p>
              </li>
              <li>
                <p className="improvements-section-description article-business-section-text">
                  - Finally, HR also needs to approve the people who will have to
                  work on these projects and build the products.{' '}
                </p>
              </li>
            </ul>
          </div>
        )}
        <p className="improvements-section-description article-business-section-text">
          {improvementsDescriptionHealthcare}
        </p>
        <p className="article-business-section-title">{improvementsResult}</p>
        <table>
          <tr>
            <th className="improvements-section-results-description">
              {improvementsResultIdeas}
            </th>
            <th className="improvements-section-results-description">
              {improvementsResultIdeasNumber}
            </th>
          </tr>
          <tr>
            <th className="improvements-section-results-description">
              {improvementsResultInvolved}
            </th>
            <th className="improvements-section-results-description">
              {improvementsResultInvolvedNumber}
            </th>
          </tr>
          <tr>
            <th className="improvements-section-results-description">
              {improvementsResultStakeholders}
            </th>
            <th className="improvements-section-results-description">
              {improvementsResultStakeholdersNumber}
            </th>
          </tr>
          <tr>
            <th className="improvements-section-results-description">
              {improvementsResultExranal}
            </th>
            <th className="improvements-section-results-description">
              {improvementsResultExranalNumber}
            </th>
          </tr>
          <tr>
            <th className="improvements-section-description-text">
              {improvementsResultAnnual}
            </th>
            <th></th>
            <th className="improvements-section-description-text">
              {improvementsResultAnnualNumber}
            </th>
          </tr>
        </table>
        <p className="improvements-section-description article-business-section-text">
          {improvementsSubDescriptionHealthcare}
        </p>
      </div>
    </div>
  );
};
export default ImprovementsComponent;
